import React, { createContext, useContext, useEffect, useState } from 'react';

// Text the pages fall back to when the API is unreachable (or a key is
// missing). Keep these in sync with the seed values in the backend's
// SeedData.cs so the site never renders empty strings.
const FALLBACK_TEXT: Record<string, string> = {
  'home.wip.text': 'Work in Progress for more info go to',
  'home.wip.linkText': 'Mark Of the knights (our itch page)',
  'home.about.title': 'About Obesquito',
  'home.about.body':
    'Obesquito is a small independent game studio founded by Shane Barnard and Vlad Sebastian Raducan. ' +
    'The studio is currently developing Mark of the Knights, a 2D action-adventure platformer set in a medieval fantasy world.',
  'motk.point1.title': 'selling point 1',
  'motk.point1.body': 'yo',
  'motk.point2.title': 'selling point 2',
  'motk.point2.body': 'yo2',
  'motk.point3.title': 'selling point 3',
  'motk.point3.body': 'yo3',
};

const SiteContentContext = createContext<Record<string, string>>(FALLBACK_TEXT);

export function SiteContentProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const [content, setContent] = useState<Record<string, string>>(FALLBACK_TEXT);

  useEffect(() => {
    let cancelled = false;
    fetch('/api/content')
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error(`HTTP ${res.status}`))))
      .then((data: Record<string, string>) => {
        if (!cancelled) setContent({ ...FALLBACK_TEXT, ...data });
      })
      .catch(() => {
        // API down: the fallback text is already in place.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return <SiteContentContext.Provider value={content}>{children}</SiteContentContext.Provider>;
}

// Read one editable string. Pages use this instead of hardcoding text.
export function useText(key: string): string {
  const content = useContext(SiteContentContext);
  return content[key] ?? FALLBACK_TEXT[key] ?? '';
}
